import React, { useEffect } from "react";

export const usePagination = (defaultPage = 0, defaultRowsPerPage = 5, onChangeCb?: () => void) => {
    const [page, setPage] = React.useState(defaultPage);
    const [rowsPerPage, setRowsPerPage] = React.useState(defaultRowsPerPage);

    useEffect(() => {
        onChangeCb?.();
    }, [page, rowsPerPage, onChangeCb]);

    const handlePageChange = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => setPage(newPage);

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return {
        page,
        rowsPerPage,
        handlePageChange,
        handleRowsPerPageChange,
    };
};
